/**
 * Pricing JS - loads on Home and Pricing page
 */

import axios from 'axios'
import Pricing from '@siteminder/pricing-api'
import pageLang from '../util/pageLang.js'

export default class LowPrice {
  constructor(el) {
    this.lang = pageLang
    this.el = el
    this.$pricing = new Pricing()
    this.$pricing.init()
    this.subregion = null
    this.rooms = 5
    this.property = 1

    // slow as this is a promise, it needs the others init first
    this.endpoint = 'https://resources.siteminder.com/services/geo/index.php'
    window.addEventListener('load', () => {
      this.request()
    })
  }

  request() {
    axios.get(this.endpoint)
      .then((response) => {
        if (response.data.request && response.data.request.status) {
          console.log('GeoIP API available')
          this.region = response.data.location.region.pricing.toLowerCase()
          this.country = response.data.location.country.code.toLowerCase()

          if (this.getTheRegion() == false) {
            if (this.region === 'uk') {
              this.region = 'emea'
              this.subregion = response.data.location.region.subregion
              this.quote()

            } else if (this.region === 'emea' || this.region === 'apac') { // pricing region emea pass subregion
              this.subregion = response.data.location.region.subregion
              this.quote()

            } else { // subregion null for the red -- set at the top
              this.quote()
            }
          } else {
            this.region = this.getTheRegion()
            this.quote()
          }
        } else {
          console.warn('GeoIP API unavailable. Defaulting request.')
          this.country = 'us'
          this.region = 'amer'
          this.quote()
        }
      })
      .catch((e) => {
        console.warn('GeoIP API error. Defaulting request.', e)
        this.country = 'us'
        this.region = 'amer'
        this.quote()
      })
  }

  // Custom regions
  getTheRegion() {
    const countryMap = {
      id: 'asiaidr',
      th: 'asiathb',
      my: 'asiadev',
    }
    return countryMap[this.country] || false
  }

  // Get the quote
  quote() {
    this.$pricing.ready(() => {
      let products = []
      if (this.lang === 'th' || this.lang === 'id' || this.lang === 'it') {
        products = ['littleHotelierFlex', 'littleHotelierPro', 'littleHotelierPremium']
      } else {
        if (this.productRegions() === 'lhFlex') {
          products = ['littleHotelierFlex', 'littleHotelierPro', 'littleHotelierPremium']
        } else if (this.productRegions() === 'lhB') {
          products = ['littleHotelierBasics', 'littleHotelierPro', 'littleHotelierPremium']
        } else {
          products = ['littleHotelierPro', 'littleHotelierPremium']
        }
      }

      var price = products.map(product => this.$pricing.lookups({
        rooms: this.rooms,
        product: product,
        region: this.region,
        subregion: this.subregion,
        term: 'monthly',
      }, 'products'))

      // console.log('Language:::', this.lang)
      // console.log('Region:::', this.region)
      // console.log('Products available:::', products)
      // console.log('Country:::', this.country)
      // console.log('Sub region:::', this.subregion)
      // console.log('Price list:::', price)

      // Remove -1 from the pricing array
      price = price.filter(num => num !== -1)
      // console.log('Remove -1 if present:::', price)

      // Get the lowest price value
      let lowestPrice = Math.min(...price)
      // console.log('Lowest price:::', lowestPrice)

      // Display the lowest price
      this.el.innerHTML = this.displayPrice(lowestPrice)
    })
  }

  productRegions() {
    if (this.region === 'asiathb' || this.region === 'asiaidr' || this.country === 'it' || this.country === 'my') {
      return 'lhFlex'
    } else if (this.region === 'apac' || this.region === 'amer' || this.subregion === 'Canada' || this.subregion === 'United Kingdom' || this.subregion === 'South Africa' || this.subregion === 'Spain' || this.subregion === 'Ireland' || this.subregion === 'Canada') {
      return 'lhB'
    } else {
      return 'restOfTheWorld'
    }
  }

  displayPrice(price) {
    const symbole = {
      default: '$',
      emea: '€',
      uk: '£',
    }

    if (this.region === 'emea') {
        if (this.subregion === 'United Kingdom' || this.subregion === 'South Africa' || this.country === 'gb' || this.country === 'za') {
            return symbole.uk + price + ' ' + this.getRegionsCurrencyCode()
        } else {
            return price + ' ' + symbole.emea
        }
    } else if (this.subregion === 'Indonesia' || this.country === 'id') { // Formate + add symbole
      return price.toLocaleString('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    } else if (this.subregion === 'Thailand' || this.country === 'th') { // Formate + add symbole
      return price.toLocaleString('th-TH', {
        style: 'currency',
        currency: 'THB',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    } else {
      return symbole.default+price + ' ' + this.getRegionsCurrencyCode()
    }
  }

  getRegionsCurrencyCode() {
    const codes = {
      apac: 'AUD',
      asia: 'USD',
      amer: 'USD',
      uk: 'GBP',
      nz: 'NZD',
    }

    const GBPCountries = ['gb', 'za']
    const EMEAUSDCountries = ['br']
    if (GBPCountries.indexOf(this.country) >= 0) {
      return codes.uk
    } else if (EMEAUSDCountries.indexOf(this.country) >= 0) {
      return codes.amer // emeausd code is 'USD'
    } else if (this.subregion === 'New Zealand & Pacific') {
      return codes.nz
    } else {
      return codes[this.region] || codes.amer
    }
  }
}

const instances = document.querySelectorAll('.low-price')
instances.forEach((instance) => {
  return new LowPrice(instance)
})



// WEBPACK FOOTER //
// ./scripts/routes/price.js